import {Button, Loader, Modal} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import React from 'react'

import {TrustFrame} from './TrustFrame'
import {useTrustModal} from './TrustModal.hooks'
import {Props} from './TrustModal.types'

const trustModal = css`
  display: block;
  position: absolute;
  inset: 0;
  border-radius: 0;
`
const classes = {
  modal: css`
    display: block;
  `,
}

export function TrustModal(props: Props): React.ReactElement<Props> {
  const {onClose, onSuccess} = props
  const {isPending, bindingUrl, bindingType, error, translates, updateHandler} = useTrustModal(props)

  return (
    <Modal className={trustModal} onClose={onClose} opened>
      <Modal.Header text={translates.subtitle} title={translates.title} />
      {bindingUrl && bindingType ? (
        <TrustFrame
          bindingType={bindingType}
          bindingUrl={bindingUrl}
          classes={classes}
          onClose={onClose}
          onSuccess={onSuccess}
          isMobile
        />
      ) : (
        <Modal.Body justifyContent="center">
          {isPending ? (
            <Loader size="m" />
          ) : error ? (
            <Button onPress={updateHandler} variant="action">
              {translates.repeat}
            </Button>
          ) : (
            '🤷'
          )}
        </Modal.Body>
      )}
    </Modal>
  )
}
